import { EntityStatusChange, ProductStatusChange } from '@/api';
import moment from 'moment';

// Find the newest date in the status array - reduces the array by the date
// if the status change's date is undefined or an empty string, return prev
export function mostRecentStatus(data: EntityStatusChange[] | ProductStatusChange[]) {
	return data.reduce((prev, curr) => {
		if (!curr.updated_at || !prev.updated_at) return prev;
		return new Date(curr.updated_at) > new Date(prev.updated_at) ? curr : prev;
	}, data[0]);
}

// Get final formatted status with all the defined values
export function getFormattedStatus(status?: string, date?: string, reason?: string) {
	const capitalizeStatus = status
		? `${status.charAt(0).toUpperCase()}${status.slice(1)}`
		: undefined;
	const values = [capitalizeStatus, date, reason];
	const definedValues = values.filter(v => v); // Filters out empty strings and undefined values
	return definedValues ? definedValues.join(' | ') : 'No Status';
}

/**
 * Get the formatted status. If issues occur 'No Status' will return
 * @param product Product for status
 * @param formattedStatus Higher level status of product
 * @param productOrEntity If status is on the product or entity
 * @returns String status with date and reason
 */
export function formattedStatus(
	product: any | null,
	formattedStatus: string | null,
	productOrEntity: 'product' | 'entity',
) {
	if (!product || !formattedStatus) return formattedStatus ?? 'No Status';

	const statusChanges: EntityStatusChange[] | ProductStatusChange[] =
		productOrEntity == 'entity' ? product.entitystatuschanges : product.productstatuschanges;
	if (!statusChanges) return formattedStatus ?? 'No Status';

	const status = mostRecentStatus(statusChanges);
	if (!status || !status.created_at) return formattedStatus ?? 'No Status';

	const date = moment(status.created_at);
	return getFormattedStatus(formattedStatus, date.format('Do MMM YYYY'), status.reason);
}
